import React, { useMemo } from 'react'
import styled from 'styled-components'
import { useUserState } from '~/atoms/UserState'
import Text, { FontStyle } from '~/components/core/Text'
import { ImageIcon } from '~/components/ImageIcon'
import ListItem from '~/components/ListItem'
import { light } from '~/constants/theme'
import { getLabelData } from '~/utils/callLogUtils'

import { CallLog } from '@mangovoice/types'

const LocateWrapper = styled.div`
  display: flex;
  align-items: center;

  > div:first-child {
    margin-right: 5px;
  }
`
interface CallLogEntryProps {
  call: CallLog
  selectedCallId?: number
  onCallLogSelected: (entry: CallLog) => void
}

const CallLogEntry = ({
  call: logEntry,
  selectedCallId,
  onCallLogSelected,
}: CallLogEntryProps) => {
  const { currentUserExtensionId: userExtensionId } = useUserState()

  const labelData = useMemo(() => {
    return getLabelData(logEntry)
  }, [logEntry, userExtensionId])

  const selected = selectedCallId === logEntry.id
  const title = (
    <Text
      fontStyle={FontStyle.Normal}
      text={labelData.title}
      weight="normal"
      color={light.dark900}
    />
  )

  const subTitle = useMemo(() => {
    return (
      <LocateWrapper>
        <ImageIcon width={9} height={10} icon={labelData.directionIconPath} />
        <Text
          fontStyle={FontStyle.Tiny}
          text={`${labelData.subTitle.replace(labelData.subTitleSubject, '')}`}
          color={light.dark700}
        />
        <Text
          style={{ whiteSpace: 'pre' }}
          fontStyle={FontStyle.Tiny}
          text={` ${labelData.subTitleSubject}`}
          color={light.dark900}
          weight="normal"
        />
      </LocateWrapper>
    )
  }, [logEntry, userExtensionId])

  return (
    <ListItem
      key={`call-log-id-${logEntry.id}`}
      activated={selected}
      title={title}
      subTitle={subTitle}
      date={
        <Text
          fontStyle={FontStyle.Tiny}
          text={labelData.date}
          color={light.dark800}
        />
      }
      time={
        <Text
          fontStyle={FontStyle.Tiny}
          text={labelData.duration}
          color={light.dark800}
        />
      }
      onClick={() => onCallLogSelected(logEntry)}
    />
  )
}

export default CallLogEntry
